// Using global event system instead of ES6 imports for Shopify theme compatibility
// @ts-ignore

class EnrollmentComponent {
  constructor() {
    this.enrollmentBanner = document.querySelector(".enrollment-banner");
    this.enrollmentForm = document.querySelector("[data-enrollment-form]");
    this.enrollmentButton = document.querySelector("[data-enrollment-button]");
    this.enrollmentError = document.querySelector("[data-enrollment-error]");
    this.enrollmentErrorText = this.enrollmentError?.querySelector(
      ".enrollment-error__text",
    );

    if (!this.enrollmentBanner || !this.enrollmentForm) return;

    this.enrollmentProductId =
      this.enrollmentBanner.querySelector('[name="id"]')?.value;
    this.renewalProductId = this.enrollmentBanner.querySelector(
      '[name="renewal_id"]',
    )?.value;
    this.renewalSellingPlanId = this.enrollmentBanner.querySelector(
      '[name="renewal_selling_plan"]',
    )?.value;
    this.isProcessing = false;
    this.originalButtonText = this.enrollmentButton?.textContent || "ENROL NOW";
    this.errorTimeout = null;

    if (!this.enrollmentProductId) return;

    this.checkCartAndInitialize();
    this.enrollmentForm.addEventListener("submit", (e) => e.preventDefault());
    this.enrollmentButton?.addEventListener(
      "click",
      this.addProduct.bind(this),
    );
  }

  checkCartAndInitialize() {
    const cart = document.querySelector("cart-items-component");
    if (cart) {
      const cartItems = cart.querySelectorAll("[data-cart-item]");
      const hasEnrollment = Array.from(cartItems).some(
        (item) => item.dataset.id === this.enrollmentProductId,
      );
      const hasRenewal = Array.from(cartItems).some(
        (item) => item.dataset.id === this.renewalProductId,
      );

      if (hasEnrollment && hasRenewal && this.enrollmentButton) {
        this.enrollmentButton.disabled = true;
        this.enrollmentButton.textContent = "Enrolled!";
      }
    }
  }

  showError(message) {
    if (!this.enrollmentError || !this.enrollmentErrorText) return;

    // Clear any existing timeout
    if (this.errorTimeout) {
      clearTimeout(this.errorTimeout);
    }

    // Set error message and show error
    this.enrollmentErrorText.textContent = message;
    this.enrollmentError.classList.remove("hidden");

    // Auto-hide error after 10 seconds
    this.errorTimeout = setTimeout(() => {
      this.hideError();
    }, 10000);
  }

  hideError() {
    if (!this.enrollmentError) return;

    this.enrollmentError.classList.add("hidden");

    if (this.errorTimeout) {
      clearTimeout(this.errorTimeout);
      this.errorTimeout = null;
    }
  }

  async addProduct(e) {
    e.preventDefault();
    if (this.isProcessing) return;

    this.isProcessing = true;

    try {
      this.enrollmentButton.disabled = true;
      this.enrollmentButton.textContent = "Joining...";

      const items = [
        {
          id: this.enrollmentProductId,
          quantity: 1,
          properties: {
            _enrollment: true,
          },
        },
        {
          id: this.renewalProductId,
          quantity: 1,
          selling_plan: this.renewalSellingPlanId,
          properties: {
            _renewal: true,
          },
        },
      ];

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: items,
        }),
      });

      this.isProcessing = false;

      const result = await response.json();

      if (!response.ok || result.status) {
        // Show error message to user
        const errorMessage =
          result.message ||
          result.description ||
          "Failed to add product to cart. Please try again.";
        this.showError(errorMessage);

        // Reset button state
        this.enrollmentButton.disabled = false;
        this.enrollmentButton.textContent = this.originalButtonText;

        return {
          success: false,
          error: errorMessage,
        };
      }

      // Success - hide any errors and update button
      this.hideError();
      this.enrollmentButton.textContent = "Enrolled!";
      this.dispatchCartEvent(result);

      setTimeout(() => {
        this.openCartDrawer();
      }, 1000);

      return { success: true, cart: result };
    } catch (error) {
      console.error("Error adding product:", error);

      // Reset button state
      this.enrollmentButton.disabled = false;
      this.enrollmentButton.textContent = this.originalButtonText;

      return { success: false, error: "Network error" };
    }
  }

  openCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer-component");
    if (cartDrawer && typeof cartDrawer.open === "function") {
      cartDrawer.open();
    }
  }

  dispatchCartEvent(cart) {
    try {
      // Create a custom event that mimics CartAddEvent
      const event = new CustomEvent("cart:update", {
        detail: {
          resource: cart,
          sourceId: this.enrollmentBanner?.id || "enrollment-banner",
          data: {
            source: "enrollment-cart",
            productId: this.enrollmentProductId,
            itemCount: cart.item_count || 0,
          },
        },
        bubbles: true,
      });
      document.dispatchEvent(event);
    } catch (error) {
      console.warn("Failed to dispatch cart event:", error);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  window.EnrollmentComponent = new EnrollmentComponent();
});
